<template>
  <div class="exception-btn-box">
    <el-button @click="$emit('export')">导出 Excel</el-button>
    <el-button type="success" @click="$emit('create')">＋ 新增异常</el-button>
  </div>
</template>

<script>
// 筛选区右侧导出、新增按钮
export default {
  name: "InterBtnBox",
};
</script>

<style scoped>
.exception-btn-box {
  margin: 16px 0 12px auto;
  text-align: right;
  white-space: nowrap;
}
</style>
